import React, { useMemo } from 'react';
import { Row, Col, Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';
import CampSessionAttendees from "./CampSessionAttendees/CampSessionAttendees";
import CampSessionCancelButton from './CampSessionCancelButton';
import WebLink from '../../../components/WebLink/WebLink';

const CampSessionSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <WebLink
                path={`/camps/session/${data.id}`}
            />

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Camp Session Details"}
                    actions={(
                        <CampSessionCancelButton session={data} />
                    )}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Date & Time",
                                key: "dateTime",
                                format: "dateTime"
                            },
                            {
                                label: "Duration (Hours)",
                                key: "duration"
                            }
                        ]}
                        columnB={[
                            {
                                label: "Status",
                                key: "status",
                                format: "titleCase"
                            },
                            {
                                label: "Venue",
                                key: "venue"
                            },
                        ]}
                        columnC={[
                            {
                                label: "Host",
                                key: "host",
                                format: "ModelLink",
                            },
                            {
                                label: "Operator",
                                key: "operator",
                                format: "ModelLink",
                            },
                            {
                                label: "Session Group",
                                key: "sessionGroup",
                                format: "ModelLink",
                            }
                        ]}
                    />

                </Panel>

                <Space />

                <CampSessionAttendees data={data} />

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default CampSessionSingleView;
